<template>
  <vue-base64-file-upload
    :ref="id"
    :id="id"
    :max-size="customImageMaxSize"
    :default-preview="src"
    :placeholder="placeholder"
    class="v1"
    accept="image/png, image/jpeg"
    image-class="profile-img"
    input-class="v1-input image-input"
    @size-exceeded="onSizeExceeded"
    @file="onFile"
    @load="onLoad"
  />
</template>
<script>
import VueBase64FileUpload from 'vue-base64-file-upload'
export default {
	name: 'file-upload',
	components: {
		VueBase64FileUpload
	},
	props: {
		src: {
			type: String,
			default: 'https://via.placeholder.com/150x150'
		},
		value: {
			type: [File, FileList, Array, String, Object],
			default: () => {
				if (this.multiple) return []
				return null
			}
		},
		placeholder: {
			type: String,
			default: ''
		}
	},
	data () {
		return {
			files: [],
			customImageMaxSize: 3 // megabytes
		}
	},
	computed: {
		id () {
			return Math.random()
				.toString()
				.replace('0.', '')
		}
	},
	methods: {
		onFile (file) {
			// console.log('file', file) // file object
		},

		onLoad (dataUri) {
			if (dataUri.startsWith('data:image/png') || dataUri.startsWith('data:image/jpeg')) {
				// console.log('DATAURI: ', dataUri) // data-uri string
				this.files.push(dataUri)
				this.$emit('input', dataUri)
				this.$emit('files-added', this.files[0])
			} else {
				this.$toasted.global.error({message: this.$t('common.error.fileType1')})
			}
		},

		onSizeExceeded (size) {
			alert(
				`Image ${size}Mb size exceeds limits of ${this.customImageMaxSize}Mb!`
			)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/common/fileUpload/index.vue